<template>
  <div
    class="toggle-container"
    :class="[`size-${size}`, `variant-${variant}`, { 'full-width': fullWidth }]"
  >
    <div
      v-for="(option, index) in options"
      :key="index"
      class="toggle-option"
      :class="{ active: value === option.value }"
      @click="selectOption(option.value)"
    >
      {{ option.label }}
    </div>
  </div>
</template>

<script>
const DEFAULT_OPTIONS = [
  { label: "Opción 1", value: "opcion1" },
  { label: "Opción 2", value: "opcion2" }
];

export default {
  name: "ToggleButton",
  props: {
    options: { type: Array, required: true, default: () => DEFAULT_OPTIONS },
    value: { type: [String, Number], required: true },
    size: {
      type: String,
      default: "medium",
      validator: value => ["small", "medium", "large"].includes(value)
    },
    variant: {
      type: String,
      default: "default",
      validator: value => ["default", "outlined", "filled"].includes(value)
    },
    fullWidth: { type: Boolean, default: false }
  },
  methods: {
    selectOption(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style scoped>
.toggle-container {
  display: inline-flex;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
}

/* Tamaños */
.size-small {
  font-size: 12px;
}

.size-small .toggle-option {
  padding: 4px 12px;
}

.size-medium {
  font-size: 14px;
}

.size-medium .toggle-option {
  padding: 8px 16px;
}

.size-large {
  font-size: 16px;
}

.size-large .toggle-option {
  padding: 12px 24px;
}

/* Variantes */
.variant-default .toggle-option {
  color: #666;
}

.variant-default .toggle-option.active {
  background-color: #ffffff;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.variant-outlined {
  background-color: transparent;
  border: 1px solid #e0e0e0;
}

.variant-outlined .toggle-option {
  color: #666;
  border: 1px solid transparent;
}

.variant-outlined .toggle-option.active {
  background-color: transparent;
  color: var(--primary-color);
  border-color: var(--primary-color);
}

.variant-filled {
  background-color: #e0e0e0;
}

.variant-filled .toggle-option {
  color: #666;
}

.variant-filled .toggle-option.active {
  background-color: var(--primary-color);
  color: white;
}

/* Ancho completo */
.full-width {
  width: 100%;
}

.full-width .toggle-option {
  flex: 1;
  text-align: center;
}

/* Estilos comunes */
.toggle-option {
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.toggle-option:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.variant-filled .toggle-option:hover {
  background-color: rgba(33, 150, 243, 0.1);
}

.variant-filled .toggle-option.active:hover {
  background-color: var(--primary-color);
}
</style>
